import MissionConfigsPage from './MissionConfigsPage';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const MissionConfigsPageConfig = {
    settings: {
        layout: {
            config: {
                footer : {
                    display: false
                }
            }
        }
    },
    auth: authRoles.cc,
    routes  : [
        {
            path     : '/cc/missionConfig',
            component: MissionConfigsPage
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/missionConfig/MissionConfigsPageConfig.js